<template>
  <Breadcrumbs
      title="Day End Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Day End Report', path: '/dayend-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DealerStatementReport />
    </div>
  </div>
</template>

<script>
import DealerStatementReport from './statement_form.vue'
export default {
  name: 'indexList',
  components: {
    DealerStatementReport,
  },
}

</script>
